import moment from 'moment'
import RECURRENCE from '@cobasi/cobasi-utils/constants/recurrence'
import { getWeek } from '@cobasi/cobasi-utils/helpers/time'
import { PET_TYPES } from '@cobasi/cobasi-utils/constants'
import { getTypeLabel } from '@cobasi/cobasi-utils/helpers/pet'

export const CNPJ_REGEX = /[A-Za-z0-9]{2}\.?[A-Za-z0-9]{3}\.?[A-Za-z0-9]{3}\/?[A-Za-z0-9]{4}-?[0-9]{2}/
export const CNPJ_INPUT_STYLE = { textTransform: 'uppercase' }
export const MIN_LENGTH_8 = /^.{8,}$/
export const AT_LEAST_ONE_CAPITAL_LETTER = /[A-Z]/
export const AT_LEAST_ONE_LOWER_LETTER = /[a-z]/
export const AT_LEAST_ONE_NUMERAL = /[0-9]/
export const PAGES = {
  FORGOT_PASSWORD_URL: '/forgot-password',
  CREATE_PASSWORD_URL: '/criar-senha'
}

export const PROFESSIONAL_ROLES = {
  VETERINARIAN: 'VETERINARIAN',
  GROOMER: 'GROOMER'
}

export const SERVICE_CATEGORY = {
  BANHO_TOSA: 'BANHO_TOSA',
  CLINICA_VET: 'CLINICA_VET',
  PERSONAL_PET: 'PERSONAL_PET'
}

export const SOLICITATION_CATEGORY = {
  AGENDA_BLOCK: 'AGENDA_BLOCK',
  SCHEDULING: 'SCHEDULING',
  AGENDA_BLOCK_UPDATE: 'AGENDA_BLOCK_UPDATE',
  SCHEDULING_UPDATE: 'SCHEDULING_UPDATE',
  OVERBOOK: 'OVERBOOK',
  OVERBOOK_UPDATE: 'OVERBOOK_UPDATE'
}

export const solicitationsOptions = [
  { value: SOLICITATION_CATEGORY.SCHEDULING, label: 'Novo agendamento' },
  { value: SOLICITATION_CATEGORY.OVERBOOK, label: 'Novo encaixe' },
  { value: SOLICITATION_CATEGORY.AGENDA_BLOCK, label: 'Novo bloqueio' },
  { value: SOLICITATION_CATEGORY.SCHEDULING_UPDATE, label: 'Alteração de agendamento' },
  { value: SOLICITATION_CATEGORY.OVERBOOK_UPDATE, label: 'Alteração de encaixe' },
  { value: SOLICITATION_CATEGORY.AGENDA_BLOCK_UPDATE, label: 'Alteração de bloqueio' }
]

export const REPORT_CATEGORY = {
  SCHEDULED: 'SCHEDULED',
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  NO_SHOW: 'NO_SHOW',
  CANCELLED: 'CANCELLED',
  RESCHEDULED: 'RESCHEDULED',
  DESIST: 'DESIST',
  RESERVED: 'RESERVED'
}

export const REPORT_TYPE = {
  OVERBOOK: 'Overbook',
  SCHEDULING: 'Scheduling'
}

export const PET_TYPE = {
  DOG: 'Cachorro',
  CAT: 'Gato',
  FERRET: 'Furão',
  RABBIT: 'Coelho',
  PIGGY_INDIAN: 'Porquinho da Índia'
}

export const reportTypes = [
  { value: REPORT_TYPE.SCHEDULING, label: 'Agendamento' },
  { value: REPORT_TYPE.OVERBOOK, label: 'Encaixe' }
]

export const reportOptions = [
  { value: REPORT_CATEGORY.SCHEDULED, label: 'Aguardando' },
  { value: REPORT_CATEGORY.IN_PROGRESS, label: 'Em andamento' },
  { value: REPORT_CATEGORY.CANCELLED, label: 'Cancelado' },
  { value: REPORT_CATEGORY.FINISHED, label: 'Realizado' },
  { value: REPORT_CATEGORY.NO_SHOW, label: 'Não veio' }
]

const WEEKDAYS = [
  'domingo',
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sábado'
]

const LABELS = {
  NONE: 'Não se repete',
  WEEKLY: weekday => `Semanalmente: cada ${weekday}`,
  MONTHLY: (week, weekday) => {
    const isMascPronoum = weekday === 'domingo' || weekday === 'sábado'
    return `Mensalmente: n${isMascPronoum ? 'o' : 'a'} ${week}${isMascPronoum ? 'º' : 'ª'} ${weekday}`
  },
  YEARLY: date => `Anualmente em ${date}`,
  WEEKDAYS: 'Dias de semana (segunda a sexta-feira)',
  EVERYDAY: 'Todos os dias'
}

export const getRecurrenceOptions = date => {
  date = moment(date)
  const week = getWeek(date)
  const weekday = WEEKDAYS[date.day()]
  const dateMonthOnly = date.format('DD/MM')
  return [
    { value: RECURRENCE.NONE, label: LABELS.NONE },
    { value: RECURRENCE.EVERYDAY, label: LABELS.EVERYDAY },
    { value: RECURRENCE.WEEKLY, label: LABELS.WEEKLY(weekday) },
    { value: RECURRENCE.MONTHLY, label: LABELS.MONTHLY(week, weekday) },
    { value: RECURRENCE.YEARLY, label: LABELS.YEARLY(dateMonthOnly) },
    { value: RECURRENCE.WEEKDAYS, label: LABELS.WEEKDAYS }
  ]
}

export const getJustificationOptions = () => {
  return [
    { value: 'Transporte', label: 'Transporte' },
    { value: 'Saúde', label: 'Saúde' },
    { value: 'Particular', label: 'Particular' },
    { value: 'Outros', label: 'Outros' }
  ]
}

export const getProfessionalCategory = () => {
  const { professional: { category } = {} } = JSON.parse(localStorage.getItem('userData')) || {}
  return category
}

export const CAMPAIGN_CATEGORY_LABEL = {
  BIRTHDAY: 'Campanha de aniversário',
  BLACK_FRIDAY: 'Campanha de black friday',
  CARNIVAL: 'Campanha de carnaval',
  INAUGURATION: 'Campanha de inauguração',
  EASTER: 'Campanha de páscoa',
  CHRISTMAS_NEWYEAR: 'Campanha de natal e ano novo',
  OTHER: 'Campanha promocional'
}

export const INITIAL_PAGE = 1

export const getDaysInMonth = (month, year) => {
  const days = []
  const currentDate = moment().format('YYYY-MM')
  const dateParams = moment(`${year}-${month}`, 'YYYY-MM')
  const daysInMonth = currentDate === dateParams ? moment().day() : moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
  for (let day = 1; day <= daysInMonth; day++) {
    const date = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD')
    const dayObj = { day: date.format('YYYY-MM-DD') }
    days.push(dayObj)
  }
  return days.sort((a, b) => new Date(b.day) - new Date(a.day))
}

export const mergeDaysWithValues = (daysWithoutValues, daysWithValues) => {
  const mergedDays = daysWithoutValues.map(day => {
    const matchingDay = daysWithValues.find(d => d.day === (day.day))
    return matchingDay ? Object.assign(day, matchingDay) : day
  })
  return mergedDays
}

export const mergeAttendanceDaysWithValues = (daysWithoutValues, daysWithValues) => {
  const mergedDays = daysWithoutValues.map(day => {
    const matchingDay = daysWithValues.some(d => d.dayOfMonth === day.day)
    matchingDay && (day.isNotEmpty = true)
    return day
  })
  return mergedDays
}

export const PET_GENDERS = {
  MALE: 'Macho',
  FEMALE: 'Fêmea'
}

export const ERROR_RETRY_SWR = 3

export const CAMPAIGN_CATEGORY_NAMES = {
  BIRTHDAY: 'Aniversário',
  BLACK_FRIDAY: 'Black friday',
  CARNIVAL: 'Carnaval',
  INAUGURATION: 'Inauguração',
  EASTER: 'Páscoa',
  CHRISTMAS_NEWYEAR: 'Natal e ano novo',
  OTHER: 'Campanha promocional'
}

export const PET_TYPES_OPTIONS = [{ label: 'Todas as espécies', value: undefined }, ...Object.values(PET_TYPES).map(type => ({ value: type, label: getTypeLabel(type) }))]

export const PET_GENDER_OPTIONS = [{ label: 'Machos e fêmeas', value: undefined }, ...Object.keys(PET_GENDERS).map(key => ({ value: key, label: PET_GENDERS[key] }))]

export const PET_BREEDS_OPTIONS = (breeds) => {
  return [{ label: 'Todas as raças', value: undefined }, ...breeds?.map(breed => ({ value: breed.id, label: breed.unaccentedName })) ?? []]
}
